/* eslint-disable @angular-eslint/no-outputs-metadata-property */
/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */

import { ChangeDetectionStrategy, Component, EventEmitter } from '@angular/core';
import { DcrTextField } from '@diekeure/dcr-components';
import { BaseProxyComponent } from '../lib/base.proxy';
import { ProxyWebComponent } from './../lib/utils';

export declare interface DcrTextFieldComponent extends DcrTextField {
  valueChange: EventEmitter<CustomEvent<string>>;
}

@ProxyWebComponent()
@Component({
    selector: `
    dcr-text-field[formControl],
    dcr-text-field[formControlName],
    dcr-text-field[ngModel]
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: '<ng-content></ng-content>',
    inputs: [
        'type',
        'value',
        'label',
        'required',
        'trailingIcon',
        'leadingIcon',
        'min',
        'max',
        'invalid',
        'validationMessage',
        'supportingText',
    ],
    outputs: ['valueChange'],
    standalone: false
})
export class DcrTextFieldComponent extends BaseProxyComponent {}
